const GOOGLE_ADS_CONVERSION_SEND_TO = 'AW-18128968406/4dVBCIuD4c0cENa1yMRD';

export function trackGoogleAdsConversion() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: GOOGLE_ADS_CONVERSION_SEND_TO });
  }
}

export function isGoogleAdsConversionLink(href: string) {
  return href.startsWith('https://wa.me/') || href.startsWith('tel:');
}
